import { useEffect, useState } from "react";
import "../assets/styles/Bet_slip.css";
import dots from "../../public/dots.png";
import del from "../../public/del.png";
import { useSelector, useDispatch } from "react-redux";
import {
  clearSelectedData,
  removeSelectedData,
  setBetData,
} from "../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import { useSearchParams } from "react-router-dom";
import { createData, myBet } from "../../../AsianExchangeSrc/api";
import { updateAvailableBalance } from "../../../AsianExchangeSrc/redux/slices/userSlice";
import { toast } from "react-toastify";
import { fetchBets } from "../../../AsianExchangeSrc/redux/slices/betsSlice";
import Loading from "./Loading";
import { getSkyUserSettings, getUserLoggedInType } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";
import { placeBet } from "../../../socketClient";

const Bet_slip = () => {
  const [stakes, setStakes] = useState("");
  const dispatch = useDispatch();
const LocalStack = getSkyUserSettings()
  console.log("LocalStack", LocalStack);  const [searchParams] = useSearchParams();
  const [odsData, setOdsData] = useState({});
  const marketId = searchParams.get("marketId");
  const eventType = Number(searchParams.get("eventType"));
  const [calculateValue, setCalculateValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const joinedMarketIds = searchParams.get("joinedMarketIds");
  const [matchesData, setMatchesData] = useState(null);

  const { cricket, soccer, tennis } = useSelector((state) => state.matches);
  useEffect(() => {
    const currentMatches =
      eventType === 4
        ? cricket.matches
        : eventType === 1
          ? soccer.matches
          : eventType === 2
            ? tennis.matches
            : [];

    setMatchesData(currentMatches || []);
  }, [eventType, cricket, soccer, tennis]);

  useEffect(() => {
    const filteredMatches = matchesData?.data?.filter(
      (e) =>
        e?.matchOdds?.some((odds) => odds?.inplay) && e?.marketId === marketId
    );
    setOdsData(filteredMatches);
  }, [matchesData]);

  const selectedData = useSelector((state) => state.marketOdds.selectedData);
  const loggedInUserType = useSelector(getUserLoggedInType());

  const handleClearAll = () => {
    dispatch(clearSelectedData());
    dispatch(
      setBetData({
        calculateValue: null,
        index: null,
        addedValue: null,
        selectionId: null,
        type: null,
        marketId:marketId
      })
    );
  };

  const handleRemoveItem = (index) => {
    dispatch(removeSelectedData(index));
  };

  const handleButtonClick = async (index, value) => {
    setStakes(value);
  };

  useEffect(() => {
    if (stakes) {
      updateCalculatedValue(Number(stakes), selectedData[0]?.index);
    }
  }, [stakes, selectedData[0]?.index]);

  const betData = selectedData[selectedData?.length - 1];

  const [formData, setFormData] = useState({});

  const updateCalculatedValue = (value, index) => {
    if (!betData?.odds) return;
    const calculatedValue = betData.odds * value - value;
    setCalculateValue(calculatedValue);

    dispatch(
      setBetData({
        calculateValue: calculatedValue,
        index,
        addedValue: value,
        selectionId: betData.selectionId,
        type: betData.oddsType,
        marketId: marketId
      })
    );
  };  

  useEffect(() => {
    if (Array.isArray(odsData)) {
      const newFormData = odsData.map((e) => ({
        type: betData?.oddsType || "",
        selection: betData?.teamName || "",
        selectionId: betData?.selectionId || "",
        oddsReq: betData?.odds || "",
        eventId: e?.eventId || "",
        legueId: e?.competitionId || "",
        joinedMarketIds: joinedMarketIds || "",
        eventType: e?.sportId || "",
        event: e?.eventName || "",
        marketId: e?.marketId || "",
        matchId: e?.eventId || "",
        market: e?.marketName || "",
        markettype: e?.marketName || "",
        runners: e?.matchRunners || "",
        sportsName: e?.sportName || "",
        againstMargin: betData?.oddsType == "Back" ? stakes : calculateValue,
        stake: stakes || "",
        favourMargin: betData?.oddsType == "Lay" ? stakes : calculateValue,
        placeTime: new Date().toISOString(),
        runnersCount: e?.matchRunners?.length,
      }));
  
      setFormData(newFormData);
    }
  }, [odsData, stakes]);

  const placeBetdata = async () => {
    setLoading(false);

    try {
      const response = await placeBet(formData);

      if (!response.success) {
        toast.warning(response.message);
      } else {
        toast.success(response.message);
        if (loggedInUserType === "real") {
          dispatch(fetchBets());
        }
        dispatch(updateAvailableBalance(response?.userData?.availableBalance));
        handleCancelClick();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);

    }
  };

  const handleInputChange = (value) => {
    setStakes(value);
  };

  return (
    <div className="bet_slip-wrap">
      {loading && <Loading />}

      <h3>
        <a className="to-expand">Bet Slip</a>
      </h3>

      <div className="bet-slip-section">
        {selectedData?.length > 0 ? (
          (() => {
            const lastItem = selectedData[selectedData?.length - 1];
            const isLay = lastItem.oddsType === "Lay";
            return (
              <div className={`bet-row ${isLay ? "bet-lay-row" : ""}`}>
                <div className="bet-title">
                  <p className="match-back">
                    {isLay ? "Lay (Bet Against)" : "Back (Bet For)"}
                  </p>
                  <div className="bet-title-odds">
                    <p>Odds</p>
                    <p>Stake</p>
                  </div>
                  <span>Profit</span>
                </div>
                <div className="bet-item">
                  <p className="bet-match">
                    <img src={dots} alt="dots" /> {lastItem.teamName}
                  </p>
                  <div className={`bet-card ${isLay ? "bet-lay" : "bet-back"}`}>
                    <div className="Match-Odds-title">
                      <div className="Match-Odds-inner">
                        <img
                          src={del}
                          alt="delete"
                          onClick={() =>
                            handleRemoveItem(selectedData?.length - 1)
                          }
                          style={{ cursor: "pointer" }}
                        />{" "}
                        Northern Warriors
                        <span> Match Odds</span>
                      </div>
                      <div className="MatchOdds-input">
                        <input value={lastItem.odds} type="number" />
                        <input
                          type="number"
                          value={LocalStack?.dedefaultStake||stakes}
                          onChange={(event) =>
                            handleInputChange(event.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="bet-buttons">
                    {LocalStack?.editStakes.map((value, index) => (
                      <button
                        key={value}
                        onClick={() => handleButtonClick(index, value)} // Pass index and value
                      >
                        {value}
                      </button>
                    ))}
                  </div>
                  <div className="min-bet">
                    <p>
                      Min Bet: <b>1</b>
                    </p>
                  </div>
                </div>
              </div>
            );
          })()
        ) : (
          <p
            style={{
              fontSize: "13px",
              fontFamily: "sans-serif",
              textAlign: "center",
              marginTop: "15px",
            }}
          >
            Click on the odds to add selections to the betslip.
          </p>
        )}

        {selectedData?.length > 0 && (
          <div>
            <div className="bet-actions">
              <p className="Liability">
                Liability <span>{stakes}</span>
              </p>
              <div className="bet-actions-btn">
                <button className="cancel-btn" onClick={handleClearAll}>
                  Cancel All
                </button>
                <button className="place-btn" onClick={placeBetdata}>
                  Place Bet
                </button>
              </div>
            </div>
            <div className="confirm-bet" style={{ paddingLeft: "10px" }}>
              <input type="checkbox" id="confirm" />
              <label htmlFor="confirm">Please confirm your bets.</label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Bet_slip;
